module.exports = __webpack_public_path__ + "img/aws.c90fe305.png";